import { Component, h } from "@stencil/core"

@Component({
  tag: "sdx-accordion-item-section",
  styleUrl: "accordion-item-section.scss",
  shadow: true,
})
export class AccordionItemSection {
  public render() {
    return <slot />
  }
}
